export const NEXT_API_URL_BACKEND_SIDE = process.env.NEXT_API_URL_BACKEND_SIDE;
log('NEXT_API_URL_BACKEND_SIDE', NEXT_API_URL_BACKEND_SIDE);
export const NEXT_PUBLIC_WS_URL_BACKEND_SIDE =
  process.env.NEXT_PUBLIC_WS_URL_BACKEND_SIDE;
log('NEXT_WS_URL_BACKEND_SIDE', NEXT_PUBLIC_WS_URL_BACKEND_SIDE);
export const NEXT_PUBLIC_API_URL_CLIENT_SIDE =
  process.env.NEXT_PUBLIC_API_URL_CLIENT_SIDE;
log('NEXT_PUBLIC_API_URL_CLIENT_SIDE', NEXT_PUBLIC_API_URL_CLIENT_SIDE);
export const NEXT_WORDPRESS_API = process.env.NEXT_WORDPRESS_API;
log('NEXT_WORDPRESS_API', NEXT_WORDPRESS_API);

export const NEXT_PUBLIC_FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL;
log('NEXT_PUBLIC_FRONTEND_URL', NEXT_PUBLIC_FRONTEND_URL);

// Environment configuration
export const NEXT_PROD = process.env.NEXT_PROD;
log('NEXT_PROD', NEXT_PROD);

// S3 Configuration (server-side only) (For hot reload of Core update)
export const NEXT_S3_ACCESS_KEY_ID = process.env.NEXT_S3_ACCESS_KEY_ID;
log(
  'NEXT_S3_ACCESS_KEY_ID',
  NEXT_S3_ACCESS_KEY_ID ? '***configured***' : 'not set'
);
export const NEXT_S3_SECRET_ACCESS_KEY = process.env.NEXT_S3_SECRET_ACCESS_KEY;
log(
  'NEXT_S3_SECRET_ACCESS_KEY',
  NEXT_S3_SECRET_ACCESS_KEY ? '***configured***' : 'not set'
);
export const NEXT_S3_REGION = process.env.NEXT_S3_REGION;
log('NEXT_S3_REGION', NEXT_S3_REGION);
export const NEXT_S3_ENDPOINT = process.env.NEXT_S3_ENDPOINT;
log('NEXT_S3_ENDPOINT', NEXT_S3_ENDPOINT);
export const NEXT_S3_BUCKET_NAME = process.env.NEXT_S3_BUCKET_NAME;
log('NEXT_S3_BUCKET_NAME', NEXT_S3_BUCKET_NAME);
export const NEXT_S3_FORCE_PATH_STYLE = process.env.NEXT_S3_FORCE_PATH_STYLE;
log('NEXT_S3_FORCE_PATH_STYLE', NEXT_S3_FORCE_PATH_STYLE);

export const NEXT_KEYCLOAK_ID = process.env.NEXT_KEYCLOAK_ID!;
log('NEXT_KEYCLOAK_ID', NEXT_KEYCLOAK_ID);
export const NEXT_KEYCLOAK_SECRET = process.env.NEXT_KEYCLOAK_SECRET!;
log('NEXT_KEYCLOAK_SECRET', NEXT_KEYCLOAK_SECRET);
export const NEXT_KEYCLOAK_ISSUER = process.env.NEXT_KEYCLOAK_ISSUER;
log('NEXT_KEYCLOAK_ISSUER', NEXT_KEYCLOAK_ISSUER);
export const NEXTAUTH_SECRET = process.env.NEXTAUTH_SECRET;
log('NEXTAUTH_SECRET', NEXTAUTH_SECRET);

export const NEXT_PUBLIC_DISABLE_AUTH = process.env.NEXT_PUBLIC_DISABLE_AUTH === 'true';
log('NEXT_PUBLIC_DISABLE_AUTH', NEXT_PUBLIC_DISABLE_AUTH);

export const NEXT_BACKEND_DOMAIN = process.env.NEXT_BACKEND_DOMAIN;
log('NEXT_BACKEND_DOMAIN', NEXT_BACKEND_DOMAIN);

export const NEXT_PUBLIC_DEBUG_LEVEL = process.env.NEXT_PUBLIC_DEBUG_LEVEL;
log('NEXT_PUBLIC_DEBUG_LEVEL', NEXT_PUBLIC_DEBUG_LEVEL);

export const NEXT_CORE_UPDATE_SECRET = process.env.NEXT_CORE_UPDATE_SECRET;
log('NEXT_CORE_UPDATE_SECRET', NEXT_CORE_UPDATE_SECRET);

export const NEXT_CDN_URL = process.env.NEXT_CDN_URL;
log('NEXT_CDN_URL', NEXT_CDN_URL);

export const NEXT_CDN_PREFIX = process.env.NEXT_CDN_PREFIX;
log('NEXT_CDN_PREFIX', NEXT_CDN_PREFIX);

// Client-accessible CDN URL (same as NEXT_CDN_URL but available on client)
export const NEXT_PUBLIC_CDN_URL = process.env.NEXT_PUBLIC_CDN_URL;
log('NEXT_PUBLIC_CDN_URL', NEXT_PUBLIC_CDN_URL);

// CDN URL specifically for sample assets (webpPath images)
export const NEXT_PUBLIC_SAMPLES_CDN_URL = process.env.NEXT_PUBLIC_SAMPLES_CDN_URL;
log('NEXT_PUBLIC_SAMPLES_CDN_URL', NEXT_PUBLIC_SAMPLES_CDN_URL);

// Client-accessible CDN prefix (same as NEXT_CDN_PREFIX but available on client)
export const NEXT_PUBLIC_CDN_PREFIX = process.env.NEXT_PUBLIC_CDN_PREFIX;
log('NEXT_PUBLIC_CDN_PREFIX', NEXT_PUBLIC_CDN_PREFIX);

export const NEXT_SSR_TAG = process.env.NEXT_SSR_TAG;
log('NEXT_SSR_TAG', NEXT_SSR_TAG);

// Client-accessible SSR tag (same as NEXT_SSR_TAG but available on client)
export const NEXT_PUBLIC_SSR_TAG = process.env.NEXT_PUBLIC_SSR_TAG;
log('NEXT_PUBLIC_SSR_TAG', NEXT_PUBLIC_SSR_TAG);

// CDN Upload Configuration
export const NEXT_CDN_RETRY_COUNT = process.env.NEXT_CDN_RETRY_COUNT || '3';
log('NEXT_CDN_RETRY_COUNT', NEXT_CDN_RETRY_COUNT);

export const NEXT_WORDPRESS_REBUILD_SECRET = process.env.NEXT_WORDPRESS_REBUILD_SECRET;
log(
  'NEXT_WORDPRESS_REBUILD_SECRET',
  NEXT_WORDPRESS_REBUILD_SECRET ? '***configured***' : 'not set'
);

function log(name: string, v: any) {
  console.log(name + ': ', v);
}

